import { getPublicFrontendBaseUrl } from '@/shared/utils/get-public-frontend-base-url';

export function buildFormPublicUrl(formCode: string): string {
  if (!formCode) {
    return '';
  }

  const base = getPublicFrontendBaseUrl();
  return base ? `${base}/rfrm?form=${formCode}` : `/rfrm?form=${formCode}`;
}
